import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function () {
  $('.srg-slick-related-slider').each(function () {
    let $slider = $(this);
    let $slider_nav = $slider.prev('.block-fullwidth-related-slider-heading');
    $slider.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false,
      speed: 500,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    });
    $slider_nav
      .find('.block-fullwidth-related-slider-arrow-right')
      .click(function () {
        $slider.slick('slickNext');
      });
    $slider_nav
      .find('.block-fullwidth-related-slider-arrow-left')
      .click(function () {
        $slider.slick('slickPrev');
      });
  });
});
